import { fetchProductData, extractData } from "../services/OpenFoodFaceService";
import { getUserData, saveScannedItem } from "../services/FireBaseService";
import UserModel from "../models/UserModel";

// Fetches user's allergens
async function getUserAllergens() {
  const userData = await getUserData();
  return userData.allergens || [];
}

// Compares product data with user's allergens
export async function checkProductSafety(productData, setStatusMessage) {
  try {
    setStatusMessage("Henter produktdata...");
    const product = await fetchProductData(productData.code);
    console.log("Modtaget produktdata:", JSON.stringify(product, null, 2));

    const userAllergens = await getUserAllergens();

    const { productName, ingredientsList, categories } = extractData(
      product,
      userAllergens.map(a => a.en)
    );

    console.log("Ingrediensliste efter udtræk:", ingredientsList);

    // Check for allergens via UserModel.isSafeProduct
    const { isSafe, detectedAllergens } = UserModel.isSafeProduct(ingredientsList, categories, userAllergens);

    const processedData = {
      productName,
      ingredientsList,
      categories,
      detectedAllergens,
      isSafe,
      
    };

    console.log("Processed product data:", processedData);

    // Save scanned item
    await saveScannedItem(processedData);

    return processedData;
  } catch (error) {
    console.error("Fejl ved produktscanning:", error.message);
    setStatusMessage("En fejl opstod under scanningen.");
    throw error;
  }
}